module.exports = __webpack_public_path__ + "img/long_1.35bc3e8b.jpg";